export const districts = [
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Moore Park Precinct",
          'district_id': 0
        },
        "geometry": {
          "coordinates": [
            [
              [
                151.22128875741032,
                -33.88623805852341
              ],
              [
                151.2177639848275,
                -33.883186074513745
              ],
              [
                151.20897100376027,
                -33.8811094044216
              ],
              [
                151.20794768268706,
                -33.884822203229355
              ],
              [
                151.1943034017189,
                -33.88608074242833
              ],
              [
                151.19274946972143,
                -33.888377528606355
              ],
              [
                151.20745497254018,
                -33.892310238046555
              ],
              [
                151.21719547312154,
                -33.89319114010315
              ],
              [
                151.22185726911835,
                -33.89117763631805
              ],
              [
                151.22128875741032,
                -33.88623805852341
              ]
            ]
          ],
          "type": "Polygon"
        }
      },
    ],
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Wynyard Precinct",
          'district_id': 1
        },
        "geometry": {
          "coordinates": [
            [
              [
                151.20515664899347,
                -33.86450015947048
              ],
              [
                151.20415906276793,
                -33.86514353833023
              ],
              [
                151.2045174189863,
                -33.87007326792891
              ],
              [
                151.2074908070561,
                -33.87033864497032
              ],
              [
                151.20601864097483,
                -33.864878145137965
              ],
              [
                151.20515664899347,
                -33.86450015947048
              ]
            ]
          ],
          "type": "Polygon"
        }
      },
    ],
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Redfern Precinct",
          'district_id': 2
        },
        "geometry": {
          "coordinates": [
            [
              [
                151.19828561178525,
                -33.8972772618129
              ],
              [
                151.20038987728708,
                -33.89301374723485
              ],
              [
                151.19990937571538,
                -33.89213351122871
              ],
              [
                151.19881582041393,
                -33.892669906126095
              ],
              [
                151.19661214079446,
                -33.89620452660029
              ],
              [
                151.19828561178525,
                -33.8972772618129
              ]
            ]
          ],
          "type": "Polygon"
        }
      },
    ],
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Chalmers St Precinct",
          'district_id': 3
        },
        "geometry": {
          "coordinates": [
            [
              [
                151.20544429104046,
                -33.890423046043004
              ],
              [
                151.20659502836617,
                -33.89021650884584
              ],
              [
                151.2076319961032,
                -33.887527332183254
              ],
              [
                151.20742748453958,
                -33.88651971797363
              ],
              [
                151.2062014338128,
                -33.88627890924353
              ],
              [
                151.20543244268498,
                -33.88791647475509
              ],
              [
                151.20522658397897,
                -33.889777615639005
              ],
              [
                151.20544429104046,
                -33.890423046043004
              ]
            ]
          ],
          "type": "Polygon"
        }
      }
    ]
  ];
  
  export const district_outliners = [
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Moore Park Precinct",
          'district_id': 0
        },
        "geometry": {
          "coordinates": [
            [
              [
                151.20451725244538,
                -33.88260632485023
              ],
              [
                151.19901366381163,
                -33.88304255779852
              ],
              [
                151.19135288968664,
                -33.88437420247653
              ],
              [
                151.18919570419217,
                -33.887657306594065
              ],
              [
                151.19038492183546,
                -33.88986127763505
              ],
              [
                151.20296850388434,
                -33.893511479407735
              ],
              [
                151.21026974709622,
                -33.89514139326758
              ],
              [
                151.21757099030657,
                -33.895164349577854
              ],
              [
                151.22407020301205,
                -33.89383287333852
              ],
              [
                151.22509348331045,
                -33.89110098632183
              ],
              [
                151.22476160861936,
                -33.887312930974254
              ],
              [
                151.22376598454605,
                -33.88398389498313
              ],
              [
                151.21845598948386,
                -33.88040216637337
              ],
              [
                151.20689568773338,
                -33.87861124568576
              ],
              [
                151.20451725244538,
                -33.88260632485023
              ]
            ]
          ],
          "type": "Polygon"
        }
      },
    ],
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Wynyard Precinct",
          'district_id': 1
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                151.20548104689527,
                -33.86258466306461
              ],
              [
                151.20488104858225,
                -33.86260913779896
              ],
              [
                151.2042868275573,
                -33.86268232633879
              ],
              [
                151.2037041055093,
                -33.86280352396242
              ],
              [
                151.20313849346297,
                -33.86297156367178
              ],
              [
                151.20259543777624,
                -33.863184827423524
              ],
              [
                151.20208016771957,
                -33.86344126170125
              ],
              [
                151.2015976451403,
                -33.86373839727932
              ],
              [
                151.20115251669583,
                -33.86407337298839
              ],
              [
                151.2007490691154,
                -33.86444296325428
              ],
              [
                151.20039118792045,
                -33.864843609145744
              ],
              [
                151.20008232000097,
                -33.86527145263258
              ],
              [
                151.19982544040857,
                -33.865722373724836
              ],
              [
                151.1996230236867,
                -33.86619203013612
              ],
              [
                151.19947702001417,
                -33.8666758990895
              ],
              [
                151.19938883639335,
                -33.86716932086385
              ],
              [
                151.19935932306524,
                -33.867667543661845
              ],
              [
                151.19938876528323,
                -33.86816576936753
              ],
              [
                151.19947688052665,
                -33.868659199753225
              ],
              [
                151.19962282118223,
                -33.86914308269066
              ],
              [
                151.19982518266926,
                -33.86961275792134
              ],
              [
                151.2000820169316,
                -33.87006370194508
              ],
              [
                151.20039085116784,
                -33.87049157159426
              ],
              [
                151.20074871162072,
                -33.87089224587351
              ],
              [
                151.2011521521974,
                -33.87126186566172
              ],
              [
                151.20159728764557,
                -33.871596870893114
              ],
              [
                151.20207983096694,
                -33.87189403485898
              ],
              [
                151.20259513470685,
                -33.87215049529906
              ],
              [
                151.20313823572366,
                -33.87236378198229
              ],
              [
                151.20370390300485,
                -33.87253184051102
              ],
              [
                151.2042866880698,
                -33.872653052118714
              ],
              [
                151.20488097747213,
                -33.87272624926989
              ],
              [
                151.20548104689527,
                -33.87275072691193
              ],
              [
                151.20608111631842,
                -33.87272624926989
              ],
              [
                151.20667540572074,
                -33.872653052118714
              ],
              [
                151.2072581907857,
                -33.87253184051102
              ],
              [
                151.2078238580669,
                -33.87236378198229
              ],
              [
                151.2083669590837,
                -33.87215049529906
              ],
              [
                151.2088822628236,
                -33.87189403485898
              ],
              [
                151.20936480614495,
                -33.871596870893114
              ],
              [
                151.20980994159316,
                -33.87126186566172
              ],
              [
                151.21021338216983,
                -33.87089224587351
              ],
              [
                151.2105712426227,
                -33.87049157159426
              ],
              [
                151.21088007685896,
                -33.87006370194508
              ],
              [
                151.2111369111213,
                -33.86961275792134
              ],
              [
                151.2113392726083,
                -33.86914308269066
              ],
              [
                151.2114852132639,
                -33.868659199753225
              ],
              [
                151.2115733285073,
                -33.86816576936753
              ],
              [
                151.2116027707253,
                -33.867667543661845
              ],
              [
                151.2115732573972,
                -33.86716932086385
              ],
              [
                151.21148507377637,
                -33.8666758990895
              ],
              [
                151.21133907010383,
                -33.86619203013612
              ],
              [
                151.21113665338194,
                -33.865722373724836
              ],
              [
                151.21087977378957,
                -33.86527145263258
              ],
              [
                151.2105709058701,
                -33.864843609145744
              ],
              [
                151.21021302467514,
                -33.86444296325428
              ],
              [
                151.20980957709472,
                -33.86407337298839
              ],
              [
                151.20936444865026,
                -33.86373839727932
              ],
              [
                151.20888192607097,
                -33.86344126170125
              ],
              [
                151.2083666560143,
                -33.863184827423524
              ],
              [
                151.20782360032757,
                -33.86297156367178
              ],
              [
                151.20725798828124,
                -33.86280352396242
              ],
              [
                151.20667526623325,
                -33.86268232633879
              ],
              [
                151.2060810452083,
                -33.86260913779896
              ],
              [
                151.20548104689527,
                -33.86258466306461
              ]
            ]
          ]
        }
      },
    ],
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Redfern Precinct",
          'district_id': 2
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                151.1986104977598,
                -33.89043348136487
              ],
              [
                151.1981265163274,
                -33.8904532174011
              ],
              [
                151.19764719523417,
                -33.8905122354682
              ],
              [
                151.19717714996332,
                -33.8906099672706
              ],
              [
                151.1967209067171,
                -33.89074547172867
              ],
              [
                151.19628285884951,
                -33.89091744403675
              ],
              [
                151.19586722457606,
                -33.89112422822239
              ],
              [
                151.19547800636622,
                -33.89136383308599
              ],
              [
                151.1951189524096,
                -33.89163395136777
              ],
              [
                151.19479352052628,
                -33.891931981957676
              ],
              [
                151.19450484486882,
                -33.89225505493488
              ],
              [
                151.1942557057359,
                -33.892600059196035
              ],
              [
                151.1940485027893,
                -33.892963672406744
              ],
              [
                151.19388523193143,
                -33.89334239298794
              ],
              [
                151.19376746606775,
                -33.89373257382981
              ],
              [
                151.1936963399386,
                -33.89413045740864
              ],
              [
                151.19367253916846,
                -33.894532211968844
              ],
              [
                151.19369629363845,
                -33.894933968421654
              ],
              [
                151.19376737524684,
                -33.89533185760561
              ],
              [
                151.19388510007988,
                -33.895722047549704
              ],
              [
                151.19404833497407,
                -33.89610078038043
              ],
              [
                151.1942555084061,
                -33.896464408517225
              ],
              [
                151.19450462560766,
                -33.89680942980744
              ],
              [
                151.19479328775986,
                -33.897132521262236
              ],
              [
                151.195118715083,
                -33.89743057106821
              ],
              [
                151.1954777735998,
                -33.89770070856605
              ],
              [
                151.1958670053149,
                -33.89794033190725
              ],
              [
                151.1962826615197,
                -33.898147133121945
              ],
              [
                151.19672073890186,
                -33.89831912035612
              ],
              [
                151.19717701811174,
                -33.898454637063715
              ],
              [
                151.19764710441322,
                -33.89855237796834
              ],
              [
                151.1981264700273,
                -33.89861140164056
              ],
              [
                151.1986104977598,
                -33.898631139569396
              ],
              [
                151.19909452549237,
                -33.89861140164056
              ],
              [
                151.1995738911064,
                -33.89855237796834
              ],
              [
                151.2000439774079,
                -33.898454637063715
              ],
              [
                151.20050025661774,
                -33.89831912035612
              ],
              [
                151.20093833399994,
                -33.898147133121945
              ],
              [
                151.20135399020472,
                -33.89794033190725
              ],
              [
                151.20174322191983,
                -33.89770070856605
              ],
              [
                151.20210228043663,
                -33.89743057106821
              ],
              [
                151.20242770775977,
                -33.897132521262236
              ],
              [
                151.202716369912,
                -33.89680942980744
              ],
              [
                151.20296548711354,
                -33.896464408517225
              ],
              [
                151.20317266054556,
                -33.89610078038043
              ],
              [
                151.20333589543978,
                -33.895722047549704
              ],
              [
                151.20345362027282,
                -33.89533185760561
              ],
              [
                151.20352470188115,
                -33.894933968421654
              ],
              [
                151.20354845635117,
                -33.894532211968844
              ],
              [
                151.20352465558105,
                -33.89413045740864
              ],
              [
                151.20345352945188,
                -33.89373257382981
              ],
              [
                151.2033357635882,
                -33.89334239298794
              ],
              [
                151.20317249273035,
                -33.892963672406744
              ],
              [
                151.20296528978372,
                -33.892600059196035
              ],
              [
                151.20271615065084,
                -33.89225505493488
              ],
              [
                151.20242747499336,
                -33.891931981957676
              ],
              [
                151.20210204311005,
                -33.89163395136777
              ],
              [
                151.20174298915342,
                -33.89136383308599
              ],
              [
                151.20135377094357,
                -33.89112422822239
              ],
              [
                151.20093813667012,
                -33.89091744403675
              ],
              [
                151.20050008880253,
                -33.89074547172867
              ],
              [
                151.2000438455563,
                -33.8906099672706
              ],
              [
                151.19957380028546,
                -33.8905122354682
              ],
              [
                151.19909447919227,
                -33.8904532174011
              ],
              [
                151.1986104977598,
                -33.89043348136487
              ]
            ]
          ]
        }
      },
    ],
    [
      {
        "type": "Feature",
        "properties": {
          'district_name': "Chalmers St Precinct",
          'district_id': 3
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                151.2063588323411,
                -33.88512582551527
              ],
              [
                151.20593357945666,
                -33.88514316786996
              ],
              [
                151.20551242147536,
                -33.885195027938714
              ],
              [
                151.20509941388414,
                -33.88528090634301
              ],
              [
                151.20469853371583,
                -33.885399976128035
              ],
              [
                151.20431364126583,
                -33.8855510907228
              ],
              [
                151.20394844293094,
                -33.885732794977024
              ],
              [
                151.2036064555269,
                -33.885943339168676
              ],
              [
                151.20329097242922,
                -33.88618069584747
              ],
              [
                151.2030050318619,
                -33.88644257935241
              ],
              [
                151.20275138763947,
                -33.88672646781576
              ],
              [
                151.2025324826445,
                -33.88702962744183
              ],
              [
                151.20235042529544,
                -33.88734913882696
              ],
              [
                151.20220696923207,
                -33.88768192506779
              ],
              [
                151.20210349641434,
                -33.888024781387074
              ],
              [
                151.20204100379803,
                -33.888374405992245
              ],
              [
                151.20202009371604,
                -33.88872743186956
              ],
              [
                151.20204096805853,
                -33.8890804592079
              ],
              [
                151.20210342630875,
                -33.88943008814001
              ],
              [
                151.20220686745455,
                -33.88977295148587
              ],
              [
                151.20235029575724,
                -33.89010574718287
              ],
              [
                151.20253233032366,
                -33.89042527009038
              ],
              [
                151.2027512183896,
                -33.89072844286224
              ],
              [
                151.20300485218723,
                -33.8910123455896
              ],
              [
                151.2032907892345,
                -33.89127424392862
              ],
              [
                151.20360627585222,
                -33.891511615441495
              ],
              [
                151.20394827368108,
                -33.89172217389717
              ],
              [
                151.204313488945,
                -33.891903891297176
              ],
              [
                151.20469840417758,
                -33.89205501741433
              ],
              [
                151.2050993121066,
                -33.892174096655516
              ],
              [
                151.20551235136978,
                -33.892259982086394
              ],
              [
                151.2059335437171,
                -33.89231184648209
              ],
              [
                151.2063588323411,
                -33.89232919029781
              ],
              [
                151.2067841209651,
                -33.89231184648209
              ],
              [
                151.2072053133124,
                -33.892259982086394
              ],
              [
                151.2076183525756,
                -33.892174096655516
              ],
              [
                151.2080192605046,
                -33.89205501741433
              ],
              [
                151.20840417573717,
                -33.891903891297176
              ],
              [
                151.2087693910011,
                -33.89172217389717
              ],
              [
                151.20911138882997,
                -33.891511615441495
              ],
              [
                151.2094268754477,
                -33.89127424392862
              ],
              [
                151.20971281249498,
                -33.8910123455896
              ],
              [
                151.20996644629258,
                -33.89072844286224
              ],
              [
                151.21018533435856,
                -33.89042527009038
              ],
              [
                151.21036736892498,
                -33.89010574718287
              ],
              [
                151.21051079722764,
                -33.88977295148587
              ],
              [
                151.21061423837344,
                -33.88943008814001
              ],
              [
                151.21067669662366,
                -33.8890804592079
              ],
              [
                151.21069757096615,
                -33.88872743186956
              ],
              [
                151.21067666088416,
                -33.888374405992245
              ],
              [
                151.21061416826785,
                -33.888024781387074
              ],
              [
                151.21051069545013,
                -33.88768192506779
              ],
              [
                151.21036723938676,
                -33.88734913882696
              ],
              [
                151.2101851820377,
                -33.88702962744183
              ],
              [
                151.20996627704272,
                -33.88672646781576
              ],
              [
                151.2097126328203,
                -33.88644257935241
              ],
              [
                151.20942669225298,
                -33.88618069584747
              ],
              [
                151.20911120915528,
                -33.885943339168676
              ],
              [
                151.20876922175125,
                -33.885732794977024
              ],
              [
                151.20840402341634,
                -33.8855510907228
              ],
              [
                151.2080191309664,
                -33.885399976128035
              ],
              [
                151.20761825079805,
                -33.88528090634301
              ],
              [
                151.20720524320683,
                -33.885195027938714
              ],
              [
                151.20678408522556,
                -33.88514316786996
              ],
              [
                151.2063588323411,
                -33.88512582551527
              ]
            ]
          ]
        }
      }
    ]
  ];